import angular from 'angular'

import wagonCtrl from './wagon.controller'
import wagonRoutes from './wagon.routes'
import wagonRun from './wagon.run'

const name = 'routingConsultWagon'

angular.module(name, [])
  .controller('wagonCtrl', wagonCtrl)
  .config(wagonRoutes)
  .run(wagonRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/wagon/wagon.module.js